import React from 'react';
import './Hero.scss';

import Section from '../components/Section';
import { Button } from '../components';

const Hero = ({
  data: {
    sectionTitle: { subTitle, title, body, button },
    imageContainer: { image, altText },
  },
}) => (
  <Section className="hero" topBottomPaddingOff>
    <div className="hero__content-wraper">
      <div className="hero__text-wraper">
        <label data-sal="slide-right" data-sal-easing="ease" data-sal-delay="50" className="label">
          {subTitle}
        </label>
        <h1 data-sal="slide-right" data-sal-easing="ease" data-sal-delay="100">
          {title}
        </h1>
        <p className="body-1" data-sal="slide-right" data-sal-easing="ease" data-sal-delay="150">
          {body}
        </p>
        <div data-sal="slide-right" data-sal-easing="ease" data-sal-delay="200">
          <Button to={button.url}>{button.text}</Button>
        </div>
      </div>
      <img
        className="hero__img"
        src={image.publicURL}
        alt={altText}
        data-sal="slide-left"
        data-sal-easing="ease"
        data-sal-delay="100"
      />
    </div>
  </Section>
);

export default Hero;
